import { useState } from "react";
import { InView } from "react-intersection-observer";
import { useQuery } from "@tanstack/react-query";

import useAppSelector from "@/hooks/useAppSelector";
import useSessionContext from "@/hooks/useSesionContext";
import SwiperSectionProductGalleryXL from "@/components/Organisms/SwiperSectionProductGalleryXL";
import { getExclusiveDiscountProducts } from "@/services/productv2";
import { snakeToCamelCase } from "@/utils/caseConverters";
import { productsDetailsEnum } from "@/recourses/queryKeys";
import { TYPE_DISCOUNT } from "@/services/checkout/type";

const ExclusiveDiscount = () => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = useAppSelector((state) => state.user?.id);
  const [inView, setInView] = useState(false);

  const {
    data: exclusiveDiscount,
    error,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: [productsDetailsEnum.getExclusiveDiscountProducts, storeId, userID, isAthenticated()],
    queryFn: async () => {
      const response = await getExclusiveDiscountProducts(storeId!, 10);
      const items: Cart[] =
        response?.payload
          // Pass the response of snake_case to CamelCase
          ?.map((item: Cart) => snakeToCamelCase(item))
          // Add the customLabel 'customer_discount' to the product
          ?.map((item: Cart) => ({
            ...item,
            details: {
              ...item.details,
              customLabel: TYPE_DISCOUNT.CUSTOMER_DISCOUNT,
            },
          })) ?? [];

      return {
        items,
      };
    },
    enabled: !!userID && !!storeId && inView,
  });

  if (error ?? !userID) {
    return null;
  }

  if (isFetching || !storeId || (!inView && !isFetched)) {
    return (
      <InView
        onChange={(isView) => {
          if (!inView) setInView(isView);
        }}
        triggerOnce
      >
        <SwiperSectionProductGalleryXL items={[]} oldDataItems={[]} isLoading />
      </InView>
    );
  }

  if (exclusiveDiscount?.items && exclusiveDiscount?.items.length <= 0) {
    return null;
  }

  return (
    <SwiperSectionProductGalleryXL
      items={exclusiveDiscount?.items ?? []}
      title="Descuentos exclusivos para ti"
    />
  );
};

export default ExclusiveDiscount;
